import {
    SET_ADMISSION_SEMAPHORE_REQUEST,
    SET_ADMISSION_SEMAPHORE_SUCCESSFULLY,
    SET_ADMISSION_SEMAPHORE_ERROR,
    RESET_ADMISSION_SEMAPHORE_REQUEST,
    RESET_ADMISSION_SEMAPHORE_SUCCESSFULLY,
    RESET_ADMISSION_SEMAPHORE_ERROR
} from './types';

const initialState = {
    isLoadingRequest: false,
    semaphoreCreated: null
};

const admissionSemaphoreReducer = (state = initialState, { type, payload }) => {
    switch (type) {
        case SET_ADMISSION_SEMAPHORE_REQUEST:
            return {
                ...state,
                isLoadingRequest: true,
            };
        case SET_ADMISSION_SEMAPHORE_SUCCESSFULLY:
            return {
                ...state,
                isLoadingRequest: false,
                semaphoreCreated: {...payload}
            };
        case RESET_ADMISSION_SEMAPHORE_REQUEST:
            return {
                ...state,
                isLoadingRequest: true,
            };
        case RESET_ADMISSION_SEMAPHORE_SUCCESSFULLY:
            return {
                ...state,
                isLoadingRequest: false,
                semaphoreCreated: null
            };
        case RESET_ADMISSION_SEMAPHORE_ERROR: 
        case SET_ADMISSION_SEMAPHORE_ERROR: 
        default:
            return state;
    }
};

export default admissionSemaphoreReducer;

